import request from '@/request'
import type * as TYPE from './types'

/**
 * 读取房间信息
 */
export const queryRoomInfo = (
  params: TYPE.RoomInfoParams
): Promise<ResponseData<TYPE.RoomData>> => {
  return request.get('/room/readRoom', { params })
}

/**
 * 房间信息保存
 */
export const saveRoomInfo = (params: TYPE.RoomData): Promise<ResponseData<TYPE.RoomData>> => {
  return request.post('/room/saveRoom', params)
}
